// @ts-strict-ignore
import React from 'react'
import styled from 'styled-components/native'

import { Colors, Metrics } from 'APP/Themes'
import Icon from 'APP/Converse/Icon'
import Typography from 'APP/Converse/Typography'
import { View } from 'react-native'
import { Notice } from 'APP/Store/Content/types'
import { NoticeType } from '@dialogue/cms'

const StyledContainer = styled(View)<{ isWarning: boolean }>`
  position: absolute;
  top: ${Metrics.baseMargin * 0.75}px;
  right: ${Metrics.baseMargin * 0.625}px;
  flex-direction: row;
  border-radius: ${Metrics.baseMargin * 1.85}px;
  border-width: 1px;
  border-color: ${Colors.appBg};
  background-color: ${({ isWarning }) =>
    isWarning ? Colors.contentCardWarningTagBg : Colors.contentCardInfoTagBg};
  padding: ${Metrics.baseMargin * 0.375}px;
`

const maxCharacters = 15
const StyledTypography = styled(Typography).attrs(() => ({
  variant: 'buttonText',
}))`
  font-size: ${({ theme }) => theme.fonts.fontSize.small}px;
  max-width: ${({ theme }) => theme.fonts.fontSize.small * maxCharacters}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StyledWarningIcon = styled(Icon).attrs(() => ({
  src: 'error',
  variant: 'materialIcons',
  size: Metrics.baseMargin,
}))`
  margin-right: ${Metrics.baseMargin * 0.625}px;
  color: ${Colors.contentCardWarningTagText};
`

const ContentCardNotice: React.FC<Notice> = ({ type, name }) => {
  const isWarning = type === NoticeType.Warning

  return (
    <StyledContainer isWarning={isWarning} testID={`${type}-${name}`}>
      {isWarning && <StyledWarningIcon />}
      <StyledTypography>{name}</StyledTypography>
    </StyledContainer>
  )
}

export default ContentCardNotice
